import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {IQuestionnaires, IQuestionnairesPayload, IQuestionnaireReprocessResult, ISurveyPreviewValidationPayload} from '../../entities/Questionnaires/Questionnaires.ts';
import {IQuestionnaireCategoryConfig} from '../../entities/Questionnaires/QuestionnaireCategoryConfig.ts';

export class QuestionnairesApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Questionnaires`;

    public static apiUrls = {
        getQuestionnaires: `${QuestionnairesApi.baseApiUrl}/all`,
        getQuestionnairesMedicalOverview: `${QuestionnairesApi.baseApiUrl}/medicaloverview`,
        getQuestionnairesById: `${QuestionnairesApi.baseApiUrl}/:id`,
        postQuestionnaires: `${QuestionnairesApi.baseApiUrl}`,
        putQuestionnaires: `${QuestionnairesApi.baseApiUrl}/:id`,
        deleteQuestionnaires: `${QuestionnairesApi.baseApiUrl}/:id`,
        reprocessCount: `${QuestionnairesApi.baseApiUrl}/:id/reprocess-count`,
        reprocessScores: `${QuestionnairesApi.baseApiUrl}/:id/reprocess-scores`,
        categories: `${QuestionnairesApi.baseApiUrl}/:id/categories`,
        validatePreview: `${QuestionnairesApi.baseApiUrl}/validate-preview`,
    };

    public static async getQuestionnaires(medicalOverview: boolean = false, patientId?: number): Promise<IQuestionnaires[]> {
        let path = medicalOverview ? this.apiUrls.getQuestionnairesMedicalOverview : this.apiUrls.getQuestionnaires;
        if (medicalOverview && patientId !== undefined) 
            path += `?patientId=${patientId}`;
        
        return this.sendApiRequest<IQuestionnaires[]>({
            method: HttpMethodEnum.GET,
            path,
            data: undefined
        });
    }
    
    public static async getQuestionnairesById(id: string): Promise<IQuestionnairesPayload> {
        return this.sendApiRequest<IQuestionnairesPayload>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getQuestionnairesById,
            data: undefined,
            id: id
        });
    }

    public static async postQuestionnaires(data: IQuestionnairesPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postQuestionnaires,
            data: data,
        });
    }

    public static async putQuestionnaires(data: IQuestionnairesPayload, id: string): Promise<any> {
        return this.sendApiRequest<IQuestionnaires>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putQuestionnaires,
            data: data,
            id: id
        });
    }

    public static async deleteQuestionnaire(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteQuestionnaires,
            data: undefined,
            id: id
        });
    }

    public static async getReprocessCount(id: string): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.reprocessCount,
            data: undefined,
            id: id
        });
    }

    public static async reprocessScores(id: string, dryRun: boolean = false): Promise<IQuestionnaireReprocessResult> {
        return this.sendApiRequest<IQuestionnaireReprocessResult>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.reprocessScores.replace(':id', id)}?dryRun=${dryRun}`,
            data: undefined
        });
    }

    public static async getCategoryConfigs(id: string): Promise<IQuestionnaireCategoryConfig[]> {
        return this.sendApiRequest<IQuestionnaireCategoryConfig[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.categories,
            data: undefined,
            id: id
        });
    }

    public static async validatePreview(data: ISurveyPreviewValidationPayload): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.validatePreview,
            data: data,
        });
    }
}
